/* ============
 * \
 * CoolDropdown Module
 * ============
 */

import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    isShowFirstElement: false,
    selectRef: null,
  },
  getters,
  mutations
};
